// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:11:27.753Z
// Property: Autumn Haus (ID: 6767906449165940)
// Collections: 27 amenities, 7 floorplans (live), 22 photos, 37 POIs, 4 reviews, 8 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449165940",
  "property_external_id": "1851599",
  "property_zillow_url": "https://www.zillow.com/apartments/leavenworth-wa/autumn-haus/CfgWnP/",
  "property_apartments_url": "https://www.apartments.com/autumn-haus-leavenworth-wa/1fly0c7/",
  "property_google_business_url": "https://www.google.com/maps/place/AutumnHaus/data=!4m2!3m1!1s0x0:0xd0baf4d2edc7a36e?sa=X&ved=2ahUKEwj28pLr47mSAxXF3RoGHXbMDUsQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "38834764603",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "autumn-haus",
  "property_name": "Autumn Haus",
  "property_website_url": "https://www.autumnhausapts.com/",
  "property_domain": "https://www.autumnhausapts.com/",
  "property_address": "1500 Autumn Strasse",
  "property_full_address": "1500 Autumn Strasse, Leavenworth, WA 98826",
  "property_address_1": "1500 Autumn Strasse",
  "property_address_2": null,
  "property_address_city": "Leavenworth",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98826",
  "property_address_country": "US",
  "property_address_county": "Chelan County",
  "property_neighborhood_address": "Washington State Area",
  "property_address_latitude": "47.60596839999999",
  "property_address_longitude": "-120.6540525",
  "property_email": "autumnhaus@weidner.com",
  "property_phone": "(360) 516-2745",
  "property_call_tracking_phone": "509-348-4386",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Mountain-town ease, modern apartment comfort.</strong> Autumn Haus pairs studio to three-bedroom layouts with fresh finishes, scenic views, and resort-style spaces close to Leavenworth’s everyday conveniences—schedule your tour today.</p>",
  "property_long_description": "<p><strong>Mountain-town ease, modern apartment comfort.</strong> At Autumn Haus, you’re close to the best of Leavenworth without giving up everyday convenience: downtown’s Bavarian storefronts and restaurants, the Wenatchee River, Leavenworth Reindeer Farm, and quick access to Highway 2 for trips toward Wenatchee or Cascade trailheads.</p><p>Choose from thoughtfully designed studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a>, including townhome-style options, with finishes that feel fresh from day one—quartz countertops, stainless steel appliances, luxury vinyl plank flooring, in-home washer/dryer, AC and heating, 9-foot ceilings, scenic views, and a private patio or balcony in select homes. Outside your door, the <a href=\"/amenities\">amenity lineup</a> brings the resort feel home with an outdoor pool, poolside lounge, fitness center, clubhouse, BBQ pavilions, fire pits, dog run, bike storage lockers, garages, and covered parking. From Waterfront Park and Blackbird Island walks to Front Street dining and Snow Lakes Trail adventures, your <a href=\"/neighborhood\">Leavenworth neighborhood</a> keeps alpine recreation and daily essentials refreshingly close.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
  "property_featured_image_media": {
    "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
    "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
    "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "368",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "15",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.67391304347827",
  "property_admin_fee": null,
  "property_application_fee": "28",
  "property_fees_deposit_info": "Deposit: $600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://autumnhausapts.securecafe.com/onlineleasing/autumn-haus/floorplans.aspx",
  "property_resident_portal_url": "https://autumnhausapts.securecafenet.com/residentservices/autumn-haus/userlogin",
  "property_apply_now_url": "https://autumnhausapts.securecafe.com/onlineleasing/autumn-haus/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
  "property_primary_logo_media": {
    "alt_text": "Autumn Haus Apartment Homes logo with a maple leaf.",
    "public_id": "019d01a9-cd4f-758a-b8e8-66935d90c017",
    "storage_key": "property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
    "width": 155,
    "height": 60
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
  "property_secondary_logo_media": {
    "alt_text": "Autumn Haus Apartment Homes logo with a colorful leaf above the text.",
    "public_id": "019d01a9-cd4f-758a-b8e8-66935d90c017",
    "storage_key": "property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
    "width": 155,
    "height": 60
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a03986-95f9-756a-9218-5316cad7a43b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Autumn Haus Apartment Homes logo",
    "public_id": "01a03986-95f9-756a-9218-5316cad7a43b",
    "storage_key": "property/6767906449165940/01a03986-95f9-756a-9218-5316cad7a43b.webp",
    "width": 180,
    "height": 70
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Autumn Haus Apartment Homes logo with a colorful leaf above the text.",
    "public_id": "019d01a9-cd4f-758a-b8e8-66935d90c017",
    "storage_key": "property/6767906449165940/019d01a9-cd4f-758a-b8e8-66935d90c017.webp",
    "width": 155,
    "height": 60
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#772f1a",
  "property_secondary_color": "#eec170",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#f58549",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "492 - 1835",
  "property_sqft_min": "492",
  "property_sqft_max": "1835",
  "property_price_range": "1265 - 2680",
  "property_price_min": "1265",
  "property_price_max": "2680",
  "property_available_units": 45,
  "property_facebook_url": "https://www.facebook.com/AutumnHausApartments",
  "property_instagram_url": "https://www.instagram.com/autumnhausapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGYhStKJTmlQRbqPH7dL0utA",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Autumn Haus",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Mountain-retreat energy, everyday ease.</strong> At Autumn Haus, amenities bring Leavenworth living home with an outdoor pool, poolside lounge, fitness center, clubhouse, BBQ pavilions, fire pits, bike storage, covered parking, and garage options. Inside, polished finishes like quartz countertops, stainless steel appliances, luxury vinyl plank flooring, in-home washer/dryer, AC and heating, and available scenic views or outdoor space keep each day feeling effortless.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore studio, one-, two-, and three-bedroom floor plans at Autumn Haus, including a townhome-style design with added separation. Open kitchens, defined bedrooms, multiple-bath options, and available outdoor space pair with quartz countertops, stainless steel appliances, luxury vinyl plank flooring, in-home washer/dryer, and year-round AC and heating.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture the everyday details at Autumn Haus.</strong> Preview open interiors with luxury vinyl plank flooring, quartz-topped kitchens, stainless steel appliances, and roomy islands, then look outside to balconies with tree-framed views, a well-equipped fitness center, sunny pool deck, clubhouse, grilling pavilions, fire pits, and pet-friendly outdoor spaces.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Leavenworth starts just beyond your door.</strong> From Autumn Haus, Cascade views, the Wenatchee River, and Highway 2 connections keep the best of town close without placing you in the busiest blocks. Head toward alpine storefronts, local breweries, and neighborhood dining, or follow the river paths through Enchantment Park and Barn Beach Reserve. Explore the map to see everyday conveniences, transit stops, and trail-town energy all within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say the difference is in the details.</strong> Autumn Haus reviews highlight quick support from Kirk and Kat, prompt maintenance, clean modern spaces, and a peaceful, welcoming setting near downtown Leavenworth. From spacious layouts to well-kept outdoor spaces with a pool, fire pits, and BBQ areas, the feedback points to everyday ease backed by a team that genuinely cares. Read the reviews to see what stands out.</p>",
  "property_neighborhood_blurb": "<p><strong>Let Leavenworth unfold from your front door.</strong> At Autumn Haus, you’re set just beyond the busiest blocks, where Cascade views, the Wenatchee River, and easy Highway 2 connections keep mountain-town living simple. Use the map to trace your route to Icicle Station, Safeway, Leavenworth Adventure Park, and local transit stops that loop through town.</p><p>When plans turn social, follow the alpine storefronts toward München Haus, Icicle Brewing, and Rhein Haus, then trade pavement for river paths at Enchantment Park or a stroll through Barn Beach Reserve. Back home, <a href=\"/amenities\">outdoor lounges and grilling spaces</a> make it easy to keep the evening going. Explore the area, compare <a href=\"/floor-plans\">available floor plans</a>, and see how Autumn Haus puts Leavenworth’s everyday conveniences and trail-town energy within reach.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make home feel like a getaway.</strong> Start your day in the fitness center, cool off at the outdoor pool, or linger by the fire pits after time spent around Leavenworth. Autumn Haus brings the best parts of a mountain retreat into your everyday routine, with a poolside lounge, clubhouse, BBQ pavilions, bike storage, covered parking, and garage options that add ease to every season.</p><p>Inside, your space is designed to feel polished and practical from the start. In-home washer/dryer, AC and heating, quartz countertops, stainless steel appliances, luxury vinyl plank flooring, and available scenic views or outdoor space help streamline the way you live. Browse the <a href=\"/gallery\">amenity photos</a>, compare available <a href=\"/floor-plans\">floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Autumn Haus in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Autumn Haus.</strong> Choose a studio, one-, two-, or three-bedroom home with fresh finishes like quartz countertops, stainless steel appliances, in-home washer/dryer, and 9-foot ceilings. When the fit feels right, begin your online application today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Autumn Haus leasing team for details on studio, one-, two-, and three-bedroom apartment homes, townhome-style options, fresh finishes, and community features—or reach out for directions to our Leavenworth location near Highway 2.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Autumn Haus?</strong> Start here for quick answers about the community, leasing, floor plans, features, and everyday living in Leavenworth. If you don’t see what you need, the leasing team is happy to help with details or next steps.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Autumn Haus floor plans move from streamlined studios to roomy one-, two-, and three-bedroom homes, including a townhome-style design with extra separation between living and sleeping areas. Compare open kitchens, defined bedrooms, multiple-bath options, and available outdoor space as you browse current pricing and availability.</p><p>Inside, modern finishes keep each plan feeling polished and practical: quartz countertops, stainless steel appliances, luxury vinyl plank flooring, in-home washer/dryer, and AC and heating for Leavenworth’s changing seasons. Select homes add 9-foot ceilings, walk-in closets, scenic or tree views, and a private patio or balcony. Start with the floor plan cards below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite layout lives in person.</p>",
  "property_gallery_blurb": "<p><strong>See Autumn Haus through the lens of everyday detail.</strong> Browse bright interiors where luxury vinyl plank floors flow from open living areas into kitchens with quartz counters, stainless steel appliances, and roomy islands made for casual meals.</p><p>The gallery also captures the way home opens outward: balconies with tree-framed views, a fitness center with plenty of equipment, and an outdoor pool set with lounge chairs and umbrellas for sunny Leavenworth afternoons. Look closer at the clubhouse, grilling pavilions, fire pits, and pet-friendly outdoor spaces, then compare <a href=\"/floor-plans\">studio to three-bedroom layouts</a> or step into a <a href=\"/virtual-tours\">virtual tour</a> for a fuller view.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Autumn Haus from every angle.</strong> Use the interactive map to find available apartments and see how close home is to downtown Leavenworth, the Wenatchee River, Highway 2, local dining, scenic walks, and Cascade trail access.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, routines, and post-walk relaxing.</strong> At Autumn Haus, your pet-friendly home is supported by everyday conveniences that make care feel easier—from in-home AC and heating after warm trail days to easy-clean luxury vinyl plank floors and available balconies for a breath of mountain air.</p><p>Step outside for quick exercise in the <a href=\"/amenities\">fenced dog run</a>, then keep the day going with Leavenworth’s leashed paths and pet-friendly outdoor spaces nearby. The community’s pet-focused touches, including office treats and occasional Yappy Hour-style gatherings, add a helpful layer beyond the policy details below. Have questions about your cat or dog before you apply? <a href=\"/contact-us\">Contact the leasing team</a> for current details.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Autumn Haus experience.</strong> If you love the mountain-town ease, modern apartment comfort, fresh finishes, and resort-style spaces, invite a friend to discover it too. Send a referral and help them find their next home in Leavenworth.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>At Autumn Haus, modern apartment comfort comes with everyday convenience. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying your Leavenworth home.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who live here.</strong> Reviews for Autumn Haus point to the details that make daily life feel easy: responsive help from Kirk and Kat, clean modern spaces, prompt maintenance, and a setting residents describe as “peaceful and welcoming.”</p><p>You’ll see praise for spacious layouts, a well-kept community, and inviting outdoor areas like the pool, fire pits, and BBQ spaces—without losing the quiet feel residents appreciate near downtown Leavenworth. Most of all, reviewers highlight a genuine sense of care from the team, from first questions to move-in and beyond. Browse the ratings below to see why residents are happy to call Autumn Haus home.</p>",
  "property_created_at": "1753982485239",
  "property_scheduletour_blurb": "<p><strong>See mountain-town ease up close.</strong> Tour Autumn Haus to experience fresh finishes, scenic views, private outdoor space in select homes, and resort-inspired community spaces—then find the studio, one-, two-, or three-bedroom layout that feels right. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture mountain-town ease with modern apartment comfort at Autumn Haus, from fresh finishes and scenic views to resort-inspired spaces close to Leavenworth’s everyday conveniences and alpine recreation.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Autumn Haus before you arrive.</strong> These virtual tours let you move room by room through the layouts available to explore, from the studio apartment to multiple one-bedroom options, including a furnished model, plus two-bedroom homes and a townhome-style three-bedroom.</p><p>Use each tour to compare open kitchen sightlines, living-room proportions, bedroom separation, storage flow, and the finishes that shape the everyday feel—quartz countertops, stainless steel appliances, luxury vinyl plank flooring, in-home laundry, and private outdoor space in select homes. It is an easy way to narrow your favorite <a href=\"/floor-plans\">floor plan</a> from anywhere, then book an in-person visit when you are ready to see Autumn Haus in Leavenworth for yourself.</p>",
  "property_copyright": "2026 All Rights Reserved. Autumn Haus",
  "property_seo_title_home": "Autumn Haus | Apartments for Rent in Leavenworth, WA",
  "property_seo_description_home": "Discover studio to 3-bedroom apartments at Autumn Haus in Leavenworth, WA. Enjoy mountain views, an outdoor pool, and modern amenities. Tour today!",
  "property_seo_title_floorplans": "Studio, 1 & 2 Bed Apartments in Leavenworth, WA | Autumn Haus",
  "property_seo_description_floorplans": "View studio, 1, 2 & 3-bedroom floor plans, pricing, and availability at Autumn Haus in Leavenworth, WA. Find your mountain-view home today!",
  "property_seo_title_amenities": "Apartment & Community Amenities | Autumn Haus Leavenworth",
  "property_seo_description_amenities": "Explore amenities at Autumn Haus in Leavenworth, WA, including a fitness center, swimming pool, private balconies, and scenic mountain views. Visit online!",
  "property_seo_title_gallery": "Photos & Apartment Gallery | Autumn Haus Leavenworth, WA",
  "property_seo_description_gallery": "Browse photo galleries of Autumn Haus Apartments in Leavenworth, WA. View apartment interior finishes, community amenities, and scenic alpine views.",
  "property_seo_title_virtualtours": "Virtual & 3D Apartment Tours | Autumn Haus Leavenworth, WA",
  "property_seo_description_virtualtours": "Take an interactive 3D virtual tour of Autumn Haus in Leavenworth, WA. Explore studio, 1, 2 & 3-bedroom layouts and community amenities from home.",
  "property_seo_title_interactivemap": "Interactive Site Map & Layouts | Autumn Haus Leavenworth",
  "property_seo_description_interactivemap": "Use our interactive site map to check real-time apartment availability, building locations, and floor plans at Autumn Haus in Leavenworth, WA.",
  "property_seo_title_neighborhood": "Location & Neighborhood Guide | Autumn Haus Leavenworth, WA",
  "property_seo_description_neighborhood": "Explore the neighborhood surrounding Autumn Haus in Leavenworth, WA. Enjoy quick access to Bavarian downtown dining, shops, outdoor recreation, and trails.",
  "property_seo_title_contact": "Contact Us & Office Hours | Autumn Haus Leavenworth, WA",
  "property_seo_description_contact": "Contact the leasing office at Autumn Haus in Leavenworth, WA. Get office hours, phone numbers, driving directions, or send an inquiry online today.",
  "property_seo_title_faqs": "Frequently Asked Questions | Autumn Haus Leavenworth, WA",
  "property_seo_description_faqs": "Find answers to common questions about leasing, pet policies, utilities, and parking at Autumn Haus in Leavenworth, WA. Read our full FAQ today.",
  "property_seo_title_reviews": "Resident Ratings & Reviews | Autumn Haus Leavenworth, WA",
  "property_seo_description_reviews": "Read verified resident reviews and ratings for Autumn Haus in Leavenworth, WA. See what residents say about our views, management, and community.",
  "property_seo_title_applynow": "Apply Online & Leasing | Autumn Haus Leavenworth, WA",
  "property_seo_description_applynow": "Apply online for studio to 3-bedroom apartments at Autumn Haus in Leavenworth, WA. Quick, secure leasing application to reserve your new home today.",
  "property_seo_title_residentaccess": "Resident Portal & Rent Pay | Autumn Haus Leavenworth, WA",
  "property_seo_description_residentaccess": "Log in to the Autumn Haus resident portal in Leavenworth, WA. Easily pay rent online, submit maintenance requests, and view community announcements.",
  "property_seo_title_referafriend": "Resident Referral Program | Autumn Haus Leavenworth, WA",
  "property_seo_description_referafriend": "Refer a friend to Autumn Haus Apartments in Leavenworth, WA. Learn about our resident referral bonus program and rewards for bringing new neighbors.",
  "property_seo_title_scheduletour": "Schedule an In-Person Tour | Autumn Haus Leavenworth, WA",
  "property_seo_description_scheduletour": "Schedule an in-person or self-guided tour of Autumn Haus in Leavenworth, WA. Select your preferred date and time to visit our apartment community.",
  "property_seo_title_privacy": "Privacy Policy | Autumn Haus Apartments",
  "property_seo_description_privacy": "Review the official privacy policy for Autumn Haus in Leavenworth, WA. Learn how we collect, safeguard, and manage your personal information.",
  "property_seo_title_accessibility": "Website Accessibility Statement | Autumn Haus",
  "property_seo_description_accessibility": "Read the website accessibility statement for Autumn Haus in Leavenworth, WA. We are committed to providing a digital experience accessible to all visitors.",
  "property_seo_title_sitemap": "Sitemap | Autumn Haus Apartments",
  "property_seo_description_sitemap": "Navigate the complete website sitemap for Autumn Haus in Leavenworth, WA. Quickly access floor plans, luxury amenities, photo galleries, and contact pages.",
  "property_seo_title_thankyou": "Thank You | Autumn Haus Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Autumn Haus in Leavenworth, WA. Our leasing team has received your message and will contact you shortly.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Leavenworth, WA | Autumn Haus",
  "property_seo_description_pets": "Explore the pet policy at Autumn Haus in Leavenworth, WA. We offer pet-friendly studio to 3-bedroom apartments. Contact our leasing office for details!",
  "property_updated_at": "1793119460507",
  "amenities": [
    {
      "id": "ec_a75de89bb95a917d75c7d838",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157568",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb94b2bb9f2a939339cd2d21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157567",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea47a7a541ef7d177e3a7ff6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157562",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fa2c5e83e4f845d727a8e30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157559",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82c47b24785fcc9a83d6d7da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157560",
      "title": "Outdoor Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab3018d3ac7f15dfd646189c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157561",
      "title": "Poolside Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b049cf4a2b821056b41b8ecf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157564",
      "title": "Dog Run",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89febf1cb575d35f2bb833db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157565",
      "title": "Two Pavilions for BBQ/Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4f4b0861cb4acf09dfb827f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157566",
      "title": "Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64454532f63cac00f689c2d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "123157569",
      "title": "Bike Storage Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1da09d3619c9cc40552921c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "128984221",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9abfa837ccaeba94fc99ee56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574955",
      "title": "In-home AC and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfbc9f38c0fec8139817d3c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574956",
      "title": "9-foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7233493ec6b180afeb5cd283",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574958",
      "title": "Scenic Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cf85d10e62ec8a423e931e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574959",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18f2636a015407f3044b0987",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574960",
      "title": "In-home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_304d7912390e9e4e5a8bd096",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "125355463",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f41f7f65665c9871bc158d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574953",
      "title": "Luxury Vinyl Plank Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25ecb45fa3a678b7c84577bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574954",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50091ffbcbc6528ab46a24d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "124574957",
      "title": "Walk-in Closets*",
      "amount": "false",
      "description": "in select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_307fa5af8f60535f7a42aace",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127375752",
      "title": "Floor Level 2",
      "amount": "false",
      "description": "Floor Leve 2",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83d0932b7ef6854636e4d19f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127375754",
      "title": "Tree View",
      "amount": "false",
      "description": "View of trees",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd3e5aad0f3e7637fa1be595",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127375755",
      "title": "Small Balcony",
      "amount": "false",
      "description": "Small Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98902baca6452004eec2bfb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127827125",
      "title": "Road Proximity",
      "amount": "false",
      "description": "Road Proximity",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_578f4e0c01702ee8ee857c3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127827126",
      "title": "Building Proximity",
      "amount": "false",
      "description": "Building Proximity",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa1ec194b0b546dbc64dd7f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127827129",
      "title": "Additional 16 Square Feet",
      "amount": "false",
      "description": "Additional 16 Square Feet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3bd27c4352b6d6982a91a80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "yardi",
      "external_id": "127827131",
      "title": "Additional 20 Square Feet",
      "amount": "false",
      "description": "Additional 20 Square Feet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_77c3d26cfcc04c801b6d3bdd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious and elegantly designed living area, perfect for entertaining or quiet evenings.",
      "link": "false",
      "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (69).jpg"
    },
    {
      "id": "ec_ad8084f753ed7d2fc52be1b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-94ca-717c-ac9e-3bc47463cb45.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, weight bench, exercise bikes, and cable machine.",
        "public_id": "01a0378b-94ca-717c-ac9e-3bc47463cb45",
        "storage_key": "property/6767906449165940/01a0378b-94ca-717c-ac9e-3bc47463cb45.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and strength training machines for residents.",
      "link": "false",
      "alt_text": "Gym with dumbbells, weight bench, exercise bikes, and cable machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (68).jpg"
    },
    {
      "id": "ec_660389977d21fb40bbce6e36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-a0bc-7422-8e3b-5439c1f0f060.webp",
      "image_media": {
        "alt_text": "Modern lobby with dark grey sectional sofa, leather chairs, coffee table, and large abstract mural.",
        "public_id": "01a0378b-a0bc-7422-8e3b-5439c1f0f060",
        "storage_key": "property/6767906449165940/01a0378b-a0bc-7422-8e3b-5439c1f0f060.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lobby, featuring comfortable seating and a stunning abstract mural. A perfect space to gather or enjoy a moment of peace.",
      "link": "false",
      "alt_text": "Modern lobby with dark grey sectional sofa, leather chairs, coffee table, and large abstract mural.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (67).jpg"
    },
    {
      "id": "ec_649dbb0fd215194ca4e31bcc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-9e5f-7716-9a55-96a2db038ef9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight benches, and dumbbells, overlooking a mountain view.",
        "public_id": "01a0378b-9e5f-7716-9a55-96a2db038ef9",
        "storage_key": "property/6767906449165940/01a0378b-9e5f-7716-9a55-96a2db038ef9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and weight benches. Enjoy your workout with a scenic mountain view.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight benches, and dumbbells, overlooking a mountain view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (66).jpg"
    },
    {
      "id": "ec_9c4ed16351930a0f07957afa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-1e6f-73fb-b77b-11a4f414bdde.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances.",
        "public_id": "01a018a3-1e6f-73fb-b77b-11a4f414bdde",
        "storage_key": "property/6767906449165940/01a018a3-1e6f-73fb-b77b-11a4f414bdde.webp",
        "width": 3072,
        "height": 1682
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island, stainless steel appliances, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (65).jpg"
    },
    {
      "id": "ec_647c9785f1b0cda1c95eee75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-2c7e-7704-bfa4-2c7fe9e2e31f.webp",
      "image_media": {
        "alt_text": "Bedroom with queen-size bed, modern decor, and large mirror.",
        "public_id": "01a018a3-2c7e-7704-bfa4-2c7fe9e2e31f",
        "storage_key": "property/6767906449165940/01a018a3-2c7e-7704-bfa4-2c7fe9e2e31f.webp",
        "width": 3072,
        "height": 1682
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen-size bed with plush bedding, a decorative mirror, and elegant nightstands. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "Bedroom with queen-size bed, modern decor, and large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (64).jpg"
    },
    {
      "id": "ec_8b346881992e34470d3c81d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-596e-72e8-84fc-914aaa6f6fda.webp",
      "image_media": {
        "alt_text": "Building exterior with mountain mural above entrance and parking lot with cars.",
        "public_id": "01a018a3-596e-72e8-84fc-914aaa6f6fda",
        "storage_key": "property/6767906449165940/01a018a3-596e-72e8-84fc-914aaa6f6fda.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Exterior view of the leasing center building featuring a mountain-themed mural and ample parking.",
      "link": "false",
      "alt_text": "Building exterior with mountain mural above entrance and parking lot with cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (63).jpg"
    },
    {
      "id": "ec_004f3d9b0152a5bd4291cf86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a2-d811-71e5-8585-ceba32b28da9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a018a2-d811-71e5-8585-ceba32b28da9",
        "storage_key": "property/6767906449165940/01a018a2-d811-71e5-8585-ceba32b28da9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable seating and lush landscaping.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (62).jpg"
    },
    {
      "id": "ec_1a89d16e8cd286e615d16dab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-1a90-71fc-a301-503e95dead4f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large vanity, sink, and toilet.",
        "public_id": "01a018a3-1a90-71fc-a301-503e95dead4f",
        "storage_key": "property/6767906449165940/01a018a3-1a90-71fc-a301-503e95dead4f.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment bathroom featuring a double vanity with ample storage, a large mirror, and a comfortable toilet. The light wood flooring adds warmth and style.",
      "link": "false",
      "alt_text": "Modern bathroom with a large vanity, sink, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (61).jpg"
    },
    {
      "id": "ec_bab2def4f15904d01621f1f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-5900-719b-bd14-8f6d47eb7c76.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstands, and access to a bathroom.",
        "public_id": "01a018a3-5900-719b-bd14-8f6d47eb7c76",
        "storage_key": "property/6767906449165940/01a018a3-5900-719b-bd14-8f6d47eb7c76.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a serene ambiance. Enjoy direct access to a well-appointed bathroom.",
      "link": "false",
      "alt_text": "Primary bedroom with a king-size bed, nightstands, and access to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (60).jpg"
    },
    {
      "id": "ec_fc2e809031d512fc2e61b1c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-9f16-7263-aa5e-f34f41d5600a.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with stainless steel appliances and modern cabinetry.",
        "public_id": "01a0378b-9f16-7263-aa5e-f34f41d5600a",
        "storage_key": "property/6767906449165940/01a0378b-9f16-7263-aa5e-f34f41d5600a.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern kitchen, perfect for cooking and entertaining. Features include stainless steel appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen and living area with stainless steel appliances and modern cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (59).jpg"
    },
    {
      "id": "ec_c7e658b19a5625c58cca3011",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01a8-9ed9-725e-8121-3d628216ff62.webp",
      "image_media": {
        "alt_text": "In-unit laundry area with stacked washer and dryer, water heater, and storage shelves.",
        "public_id": "019d01a8-9ed9-725e-8121-3d628216ff62",
        "storage_key": "property/6767906449165940/019d01a8-9ed9-725e-8121-3d628216ff62.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area featuring a stacked washer and dryer, a water heater, and ample storage shelving for your convenience.",
      "link": "false",
      "alt_text": "In-unit laundry area with stacked washer and dryer, water heater, and storage shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (58).jpg"
    },
    {
      "id": "ec_44394036c811e130ddb76538",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-d4fd-733f-bc11-3eb9b70d7035.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and cabana on a sunny day.",
        "public_id": "01a0378b-d4fd-733f-bc11-3eb9b70d7035",
        "storage_key": "property/6767906449165940/01a0378b-d4fd-733f-bc11-3eb9b70d7035.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, furnished with comfortable lounge chairs and a shaded cabana, set against a backdrop of lush green trees and mountains.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and cabana on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (57).jpg"
    },
    {
      "id": "ec_03eb36ae17f1a4e1ad278388",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-d562-747a-8109-d597cd63dd97.webp",
      "image_media": {
        "alt_text": "Spacious living room with wood-look flooring and doors leading to other rooms.",
        "public_id": "01a0378b-d562-747a-8109-d597cd63dd97",
        "storage_key": "property/6767906449165940/01a0378b-d562-747a-8109-d597cd63dd97.webp",
        "width": 3072,
        "height": 1755
      },
      "title": "Apartment",
      "description": "A bright and airy living space featuring modern wood-look flooring and access to additional rooms, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Spacious living room with wood-look flooring and doors leading to other rooms.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (56).jpg"
    },
    {
      "id": "ec_21cb1dc6b3377fb8dc668201",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-d0b3-777d-8448-fd48c7c09459.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and open living area.",
        "public_id": "01a0378b-d0b3-777d-8448-fd48c7c09459",
        "storage_key": "property/6767906449165940/01a0378b-d0b3-777d-8448-fd48c7c09459.webp",
        "width": 3072,
        "height": 1682
      },
      "title": "Apartment",
      "description": "Spacious and stylish apartment kitchen featuring a large island, stainless steel appliances, and a seamless flow into the living and dining areas.",
      "link": "false",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and open living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (55).jpg"
    },
    {
      "id": "ec_660b0f186befcb492a6c9efe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-4766-72aa-9376-6cd8c1c6614a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a closet and view of a kitchen.",
        "public_id": "01a018a3-4766-72aa-9376-6cd8c1c6614a",
        "storage_key": "property/6767906449165940/01a018a3-4766-72aa-9376-6cd8c1c6614a.webp",
        "width": 3072,
        "height": 1755
      },
      "title": "Apartment",
      "description": "Spacious bedroom with modern flooring and a large closet, offering a glimpse into the adjacent kitchen area.",
      "link": "false",
      "alt_text": "Empty bedroom with a closet and view of a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (54).jpg"
    },
    {
      "id": "ec_6f3d65b06b758b10e3b633c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-71b0-765b-8dc4-5b16cd24a316.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into kitchen",
        "public_id": "01a018a3-71b0-765b-8dc4-5b16cd24a316",
        "storage_key": "property/6767906449165940/01a018a3-71b0-765b-8dc4-5b16cd24a316.webp",
        "width": 3072,
        "height": 1755
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a large closet, offering a glimpse into the modern kitchen with sleek cabinetry and stainless steel appliances.",
      "link": "false",
      "alt_text": "Bedroom with closet and view into kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (53).jpg"
    },
    {
      "id": "ec_45258bc18e5fdbfb7d49098d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-ea75-757a-891f-1b97b986a5d1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "01a0378b-ea75-757a-891f-1b97b986a5d1",
        "storage_key": "property/6767906449165940/01a0378b-ea75-757a-891f-1b97b986a5d1.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in our beautifully designed kitchens, featuring stainless steel appliances, sleek granite countertops, and abundant storage.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (52).jpg"
    },
    {
      "id": "ec_c2966c67a1ea671ad7237a5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-e352-724d-af24-c4a3f4b3e87c.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a large sectional sofa, coffee table, and lounge chairs under a black canopy.",
        "public_id": "01a0378b-e352-724d-af24-c4a3f4b3e87c",
        "storage_key": "property/6767906449165940/01a0378b-e352-724d-af24-c4a3f4b3e87c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors in this comfortable seating area, complete with a shaded canopy and plush lounge chairs. Perfect for unwinding or entertaining guests.",
      "link": "false",
      "alt_text": "Outdoor seating area with a large sectional sofa, coffee table, and lounge chairs under a black canopy.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (51).jpg"
    },
    {
      "id": "ec_6cb009f4fdb0f86ea156d63e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01a8-91d5-766b-b0f8-47728e8338b1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools, stainless steel appliances, and a contemporary art piece.",
        "public_id": "019d01a8-91d5-766b-b0f8-47728e8338b1",
        "storage_key": "property/6767906449165940/019d01a8-91d5-766b-b0f8-47728e8338b1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this stylish apartment kitchen, featuring a spacious island with seating, sleek cabinetry, and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with island and bar stools, stainless steel appliances, and a contemporary art piece.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (50).jpg"
    },
    {
      "id": "ec_bfe9a1ad9b3e86738ea51fa2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a018a3-7b06-7739-8c1f-5d9f81663016.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, quartz countertops, and ample cabinet space.",
        "public_id": "01a018a3-7b06-7739-8c1f-5d9f81663016",
        "storage_key": "property/6767906449165940/01a018a3-7b06-7739-8c1f-5d9f81663016.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Experience the heart of your home with this stylish and functional kitchen, featuring sleek stainless steel appliances, elegant quartz countertops, and generous cabinet storage for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, quartz countertops, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (71).jpg"
    },
    {
      "id": "ec_1b653e37b4513b6b44f8783a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/01a0378b-f787-74cf-85d8-61ca6954a0cd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a0378b-f787-74cf-85d8-61ca6954a0cd",
        "storage_key": "property/6767906449165940/01a0378b-f787-74cf-85d8-61ca6954a0cd.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Autumn_Haus_Favorites (70).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c754e3e0-79dc-4c17-9baa-427a16ac0b43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "München Haus",
      "poi_type": "Restaurants",
      "poi_address": "709 Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Bratwursts, hot dogs, and other German eats in a laid-back setting with live music and beer.",
      "poi_long_description": "People say this German restaurant serves delicious bratwurst, pretzels, and apple cider sauerkraut. They highlight the wide variety of mustards and toppings, and the cozy outdoor beer garden with fire pits and heaters. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-1a92-7008-b457-8ec2fe1089cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-1a92-7008-b457-8ec2fe1089cb",
        "storage_key": "property/6767906449165940/019d01aa-1a92-7008-b457-8ec2fe1089cb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.munchenhaus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13332363898967916185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "mnchen-haus",
      "poi_latitude": "47.59452479999999",
      "poi_longitude": "-120.663014",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-1158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5063-72ca-8a0a-54b6630c1a58",
        "storage_key": "property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1R3qIxNmlQRmX45BlQSBrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9bbd396a-1707-474e-af78-b079d83137ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Andreas Keller Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "829 Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Quaint, family-owned German spot since 1989 with old-world flair, Bavarian recipes & imported beers.",
      "poi_long_description": "People say this German restaurant serves delicious Schnitzel Cordon Bleu, Jägerschnitzel, and Apple Strudel. They also highlight the fun, authentic atmosphere with live accordion music, and the friendly, efficient service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-1a01-7514-8960-4e463155d410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-1a01-7514-8960-4e463155d410",
        "storage_key": "property/6767906449165940/019d01aa-1a01-7514-8960-4e463155d410.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.andreaskellerrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14977086588479717989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "andreas-keller-restaurant",
      "poi_latitude": "47.595355",
      "poi_longitude": "-120.661492",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5063-72ca-8a0a-54b6630c1a58",
        "storage_key": "property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4WEgoxNmlQRZcKZdOZM2c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6c5bc039-591b-4e57-81fe-17a7378644d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Yodelin Broth Company and Beer Garden",
      "poi_type": "Restaurants",
      "poi_address": "633 Front St #1346, Leavenworth, WA 98826, USA",
      "poi_short_description": "Cozy, kid-friendly restaurant dishing up Pacific Northwest comfort food made with locally sourced ingredients.",
      "poi_long_description": "People say this restaurant serves delicious bone broth, rice bowls, and fish sandwiches, with fresh, healthy, and flavorful ingredients. They highlight the generous portions, sustainable practices, and beautiful mountain views from the outdoor seating. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-19b9-76c5-b5cc-4783d696da61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-19b9-76c5-b5cc-4783d696da61",
        "storage_key": "property/6767906449165940/019d01aa-19b9-76c5-b5cc-4783d696da61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://yodelinbroth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3917767555032066837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "yodelin-broth-company-and-beer-garden",
      "poi_latitude": "47.5943577",
      "poi_longitude": "-120.6639886",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5063-72ca-8a0a-54b6630c1a58",
        "storage_key": "property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQJpq4xNmlQRFas8htW0XjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_42811760-306c-4d59-a968-af1e8b01260c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Larch Handcrafted Pasta & cocktails",
      "poi_type": "Restaurants",
      "poi_address": "214 8th St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Italian fare such as handmade pasta and mushroom ravioli served in an upscale setting with wine and cocktails.",
      "poi_long_description": "People say this restaurant serves delicious homemade pasta dishes, including mushroom ravioli, pappardelle, and lasagna, as well as focaccia and tiramisu. They highlight the generous portions, reasonable prices, and cozy, inviting atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-1ae6-732c-a1e1-11689b8195b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-1ae6-732c-a1e1-11689b8195b4",
        "storage_key": "property/6767906449165940/019d01aa-1ae6-732c-a1e1-11689b8195b4.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.larchleavenworth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911973829398729338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "larch-handcrafted-pasta--cocktails",
      "poi_latitude": "47.5947942",
      "poi_longitude": "-120.6618112",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-888-2343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5063-72ca-8a0a-54b6630c1a58",
        "storage_key": "property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSy8nwPVNmlQRepInWRGyiBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2a163ab7-359a-4723-b819-bca161413766",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Gustav's",
      "poi_type": "Restaurants",
      "poi_address": "617 US-2, Leavenworth, WA 98826, USA",
      "poi_short_description": "Pub grub, beer, and cocktails in a historic setting with rooftop seating.",
      "poi_long_description": "People say this restaurant serves delicious brats, burgers, and pretzel sticks. They also highlight the friendly staff, rooftop deck, and unique menu.\n\nOther reviews mention the fries can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-1e8b-75cc-9222-a708e68b3631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-1e8b-75cc-9222-a708e68b3631",
        "storage_key": "property/6767906449165940/019d01aa-1e8b-75cc-9222-a708e68b3631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gustavsleavenworth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13939032253650733353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "gustavs",
      "poi_latitude": "47.5942619",
      "poi_longitude": "-120.6646809",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-548-4509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5063-72ca-8a0a-54b6630c1a58",
        "storage_key": "property/6767906449165940/019d01aa-5063-72ca-8a0a-54b6630c1a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_F8GBDYmVQRKYmQh_tjccE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_268cc8f7-6774-4a49-beb7-b2fc79141e62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "116 River Bend Dr, Leavenworth, WA 98826, USA",
      "poi_short_description": "Chain grocery outpost with a pharmacy, deli, bakery, butcher, and florist, plus a gas station.",
      "poi_long_description": "People say this grocery store is clean and well-stocked. They also highlight the friendly and outgoing staff, and the fast checkout.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-1eb7-704f-8826-e378a6712da8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-1eb7-704f-8826-e378a6712da8",
        "storage_key": "property/6767906449165940/019d01aa-1eb7-704f-8826-e378a6712da8.webp",
        "width": 520,
        "height": 292
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/leavenworth/116-riverbend-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=18314805689797897597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.5971995",
      "poi_longitude": "-120.6451529",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-548-5435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-fd07651e1293",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2xN_INNmlQRfe20Jr1CK_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2fe1abd1-ad93-4b00-b5dd-88a58b620792",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Dan's Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1329 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "Grocery store supplying produce, sandwiches, and other staples.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, baked goods, and deli items, including sandwiches, fried chicken, and salads. They highlight the reasonable prices, convenient hours, and easy parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2086-7370-8a37-c179ffa0a5a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2086-7370-8a37-c179ffa0a5a6",
        "storage_key": "property/6767906449165940/019d01aa-2086-7370-8a37-c179ffa0a5a6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.dansfoodmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11000007061175112438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "dans-food-market",
      "poi_latitude": "47.5988293",
      "poi_longitude": "-120.655318",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-5611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-fd07651e1293",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29Gs5ohNmlQR9pIhQCTgp5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fe455054-f59e-48c1-afda-eea6a4b635e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Christmas Lights",
      "poi_type": "Shopping & Retail",
      "poi_address": "Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-210f-736a-8a7c-837a5c1be852.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-210f-736a-8a7c-837a5c1be852",
        "storage_key": "property/6767906449165940/019d01aa-210f-736a-8a7c-837a5c1be852.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14265010414055841783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "christmas-lights",
      "poi_latitude": "47.5958374",
      "poi_longitude": "-120.6609944",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5059-770c-9ebc-a0be00be88ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5059-770c-9ebc-a0be00be88ba",
        "storage_key": "property/6767906449165940/019d01aa-5059-770c-9ebc-a0be00be88ba.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNRAjdotNmlQR998Lb2R_98U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c061fdfc-1b20-4990-bb3d-dc458d66e5c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "A Book For All Seasons",
      "poi_type": "Shopping & Retail",
      "poi_address": "707 US Hwy 2 B, Leavenworth, WA 98826, USA",
      "poi_short_description": "Small, charming bookstore with a good selection, including children's books, and used volumes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2311-726e-962e-42c8ec6e34e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2311-726e-962e-42c8ec6e34e4",
        "storage_key": "property/6767906449165940/019d01aa-2311-726e-962e-42c8ec6e34e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.abookforallseasons.com/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=18384772601205827303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "a-book-for-all-seasons",
      "poi_latitude": "47.5950989",
      "poi_longitude": "-120.6628589",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-1451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5059-770c-9ebc-a0be00be88ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5059-770c-9ebc-a0be00be88ba",
        "storage_key": "property/6767906449165940/019d01aa-5059-770c-9ebc-a0be00be88ba.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0caVItNmlQR5yY1K0bVI_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_94a46fbf-7985-42db-84eb-62bbf6094c81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "A Matter of Taste",
      "poi_type": "Shopping & Retail",
      "poi_address": "647 Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Specialty shop offering dips, marinades, and sauces, plus books, jewelry, and other gift items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-23c5-75ad-b67c-9b027ca27e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-23c5-75ad-b67c-9b027ca27e3a",
        "storage_key": "property/6767906449165940/019d01aa-23c5-75ad-b67c-9b027ca27e3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amatteroftasteinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1405964747930900277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "a-matter-of-taste",
      "poi_latitude": "47.5944983",
      "poi_longitude": "-120.663259",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-6949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-fd07651e1293",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-fd07651e1293.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSHDqYxNmlQRNZckN339ghM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8d379021-f144-4557-abd1-aa369f12a31a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Leavenworth Public Library",
      "poi_type": "Education",
      "poi_address": "700 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2502-72b9-8d25-b69bc0907676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2502-72b9-8d25-b69bc0907676",
        "storage_key": "property/6767906449165940/019d01aa-2502-72b9-8d25-b69bc0907676.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.ncwlibraries.org/locations/leavenworth-public-library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8710749592555821369&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "leavenworth-public-library",
      "poi_latitude": "47.59511999999999",
      "poi_longitude": "-120.664137",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-f82a5ec3fc59",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGb0uUYtNmlQRORmrV5rM4ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5e8b9065-2f52-4525-9953-ed9962f3f1b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Peshastin Public Library",
      "poi_type": "Education",
      "poi_address": "8396 Main St, Peshastin, WA 98847, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-262a-77ad-96b7-82c78b22d356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-262a-77ad-96b7-82c78b22d356",
        "storage_key": "property/6767906449165940/019d01aa-262a-77ad-96b7-82c78b22d356.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ncwlibraries.org/locations/peshastin-public-library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3555774724303334425&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "peshastin-public-library",
      "poi_latitude": "47.569505",
      "poi_longitude": "-120.60423",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 509-548-7821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-f82a5ec3fc59",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4wwLF1RMmlQRGaxpv0WmWDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e73acd9e-9cf7-4899-a95c-8770369f26bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Upper Valley Christian School",
      "poi_type": "Education",
      "poi_address": "111 Ski Hill Dr, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-282f-7319-acb8-262efe200dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-282f-7319-acb8-262efe200dcd",
        "storage_key": "property/6767906449165940/019d01aa-282f-7319-acb8-262efe200dcd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.uvcschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854964506506751465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "upper-valley-christian-school",
      "poi_latitude": "47.593637",
      "poi_longitude": "-120.6690379",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-548-5292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-f82a5ec3fc59",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEwWMEo5NmlQR6e1qPAHew4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8b77cb55-dca0-45c9-b6a3-12f99500d19b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Leavenworth Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "9342 Icicle Rd, Leavenworth, WA 98826, USA",
      "poi_short_description": "Amusement park offering an alpine coaster, mining sluice, climbing wall, and dining.",
      "poi_long_description": "People say this amusement park offers a thrilling alpine coaster, a climbing wall, and gem mining. They also highlight the fun experience, the beautiful views, and the friendly staff.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2a7d-7626-b52a-730cfb02fb09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2a7d-7626-b52a-730cfb02fb09",
        "storage_key": "property/6767906449165940/019d01aa-2a7d-7626-b52a-730cfb02fb09.webp",
        "width": 838,
        "height": 730
      },
      "poi_business_url": "https://www.leavenworthadventurepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3642714369215788539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "leavenworth-adventure-park",
      "poi_latitude": "47.58776959999999",
      "poi_longitude": "-120.675083",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-888-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH76aA1pNmlQR-3VRO2uFjTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_12eaa4df-9be2-4b02-8287-58f182a5b8e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Leavenworth Nutcracker Museum",
      "poi_type": "Entertainment",
      "poi_address": "735 Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Displays of over 9,000 nutcrackers including Steinbach, in a venue with a scavenger hunt.",
      "poi_long_description": "People say this museum offers a diverse and fascinating collection of nutcrackers from around the world, with a self-guided tour and a fun nutcracker hunt for kids. They highlight the affordable admission price and the strong community roots of this local nonprofit. They also like the informative video and historical information provided.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2bdf-774c-8fd2-04c913562473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2bdf-774c-8fd2-04c913562473",
        "storage_key": "property/6767906449165940/019d01aa-2bdf-774c-8fd2-04c913562473.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "http://www.nutcrackermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4877370320298451213&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "leavenworth-nutcracker-museum",
      "poi_latitude": "47.5948804",
      "poi_longitude": "-120.6623574",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-4573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-545b-770e-8c73-7109b7cd1433",
        "storage_key": "property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmS14oYxNmlQRDSFsA3fmr0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3a9ebbd7-f8e4-4b37-a99b-be18dbec3655",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Greater Leavenworth Museum",
      "poi_type": "Entertainment",
      "poi_address": "735 Front St 2nd Floor, Leavenworth, WA 98826, USA",
      "poi_short_description": "Exhibits exploring the history of Leavenworth, from Native American settlement to its present-day Bavarian theme.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2e74-7364-9961-ed193466295b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2e74-7364-9961-ed193466295b",
        "storage_key": "property/6767906449165940/019d01aa-2e74-7364-9961-ed193466295b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://leavenworthmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983435652382556474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "greater-leavenworth-museum",
      "poi_latitude": "47.5948723",
      "poi_longitude": "-120.6624223",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-0728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-545b-770e-8c73-7109b7cd1433",
        "storage_key": "property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSXVooYxNmlQROoHXKiGTq3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_44fc95c5-100d-4985-ba34-512ead20810f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "God's World Exploration Station",
      "poi_type": "Entertainment",
      "poi_address": "90 Elderberry Ln, Peshastin, WA 98847, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-2e4e-75cb-9800-c8b931c54fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-2e4e-75cb-9800-c8b931c54fb0",
        "storage_key": "property/6767906449165940/019d01aa-2e4e-75cb-9800-c8b931c54fb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://godsworldexplorationstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8678043276981607701&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "gods-world-exploration-station",
      "poi_latitude": "47.5152793",
      "poi_longitude": "-120.6291173",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 360-367-1107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-545b-770e-8c73-7109b7cd1433",
        "storage_key": "property/6767906449165940/019d01aa-545b-770e-8c73-7109b7cd1433.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2mP_05JmlQRFZ301WGabng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a78cedf3-127e-4f9b-83db-9474c7d3342d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Historic Tumwater Dam",
      "poi_type": "Entertainment",
      "poi_address": "13855 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-30a3-7509-b2ca-c78a603f5bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-30a3-7509-b2ca-c78a603f5bf7",
        "storage_key": "property/6767906449165940/019d01aa-30a3-7509-b2ca-c78a603f5bf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13383111264250938546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "historic-tumwater-dam",
      "poi_latitude": "47.6171188",
      "poi_longitude": "-120.7229819",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6UCXz9TmlQRssQ0v8lcurk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_9403fef7-448e-4851-bb14-0696e9d199a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Club West Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10421 Titus Rd, Leavenworth, WA 98826, USA",
      "poi_short_description": "Local gym featuring weight machines, free weights, and a sauna, plus racquetball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3257-774f-8ff7-c0356c05c745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3257-774f-8ff7-c0356c05c745",
        "storage_key": "property/6767906449165940/019d01aa-3257-774f-8ff7-c0356c05c745.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://clubwestfitness4.wixsite.com/clubwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=3767020296318121113&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "club-west-fitness-center",
      "poi_latitude": "47.6059875",
      "poi_longitude": "-120.6573104",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-4028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fbzJnpSmlQRmXS6PwAlRzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a042fe37-3364-417b-bb37-f41937414ddb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Woody's Classic Man - Leavenworth",
      "poi_type": "Health and Wellness",
      "poi_address": "217 8th St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Barbershop featuring traditional cuts and straight-razor shaves, plus a beer and cider bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3449-7732-9151-70d103529e5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3449-7732-9151-70d103529e5d",
        "storage_key": "property/6767906449165940/019d01aa-3449-7732-9151-70d103529e5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodysclassicman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3680102532428567652&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "woodys-classic-man---leavenworth",
      "poi_latitude": "47.5945798",
      "poi_longitude": "-120.6621063",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-300-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVegxg5NmlQRZJRrVsFZEjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d4223267-90fe-4724-9f97-403998c98341",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Cascade Veterinary Clinics: Leavenworth",
      "poi_type": "Health and Wellness",
      "poi_address": "11777 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-361f-766b-9f49-085b395ac51b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-361f-766b-9f49-085b395ac51b",
        "storage_key": "property/6767906449165940/019d01aa-361f-766b-9f49-085b395ac51b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cascadevetclinics.com/contact-leavenworth/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7699167720536890542&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cascade-veterinary-clinics-leavenworth",
      "poi_latitude": "47.597382",
      "poi_longitude": "-120.6492267",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-5896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0x7AioVNmlQRrlzB-D_w2Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_630ba233-f147-458e-b825-0a81ad4b9e07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Alpine Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10090 Main St F, Peshastin, WA 98847, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3758-71da-b678-b1df5a0046df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3758-71da-b678-b1df5a0046df",
        "storage_key": "property/6767906449165940/019d01aa-3758-71da-b678-b1df5a0046df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alpinefitleavenworth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4684227500451866455&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "alpine-fitness",
      "poi_latitude": "47.57193179999999",
      "poi_longitude": "-120.603319",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 360-710-6518",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9xtnpZNmlQRV6eM8xe4AUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b029bf5e-2abd-40ff-85b6-5169629ae640",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "ALPINE HOT YOGA",
      "poi_type": "Health and Wellness",
      "poi_address": "213 14th St, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-386c-710d-9532-daa45b001e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-386c-710d-9532-daa45b001e98",
        "storage_key": "property/6767906449165940/019d01aa-386c-710d-9532-daa45b001e98.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.alpinehotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3352366704324447842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "alpine-hot-yoga",
      "poi_latitude": "47.5986059",
      "poi_longitude": "-120.6543872",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-0349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-f82a5ec3fc59",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBZUz3IhNmlQRYg4biMH_hS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_166925b2-b5e8-4e54-a713-0a63a2c624f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "BALANCE POINT HEALTH & FITNESS",
      "poi_type": "Health and Wellness",
      "poi_address": "10171 Chumstick Hwy, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mtstuartpt.com/balance-point-health-and-fitness-lp/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14483959710479212725&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "balance-point-health--fitness",
      "poi_latitude": "47.6021716",
      "poi_longitude": "-120.6505029",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-4378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZfEoIdNmlQRteAuDJ5cAck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6b9d3187-d3f3-4ad7-a5cb-6e4f3b08e696",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Awake Bodies",
      "poi_type": "Health and Wellness",
      "poi_address": "217 14th St, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3a43-775a-9135-ab0fc09ddc1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3a43-775a-9135-ab0fc09ddc1f",
        "storage_key": "property/6767906449165940/019d01aa-3a43-775a-9135-ab0fc09ddc1f.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.awakebodies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13333324408656719748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "awake-bodies",
      "poi_latitude": "47.5985103",
      "poi_longitude": "-120.6541388",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-669-9936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5057-76cc-bd75-f82a5ec3fc59",
        "storage_key": "property/6767906449165940/019d01aa-5057-76cc-bd75-f82a5ec3fc59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52PRn6JNmlQRhG8HHeh7Cbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e495720-5aff-4ef4-ab5a-4a754879e22a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Autumn's in the Hair",
      "poi_type": "Health and Wellness",
      "poi_address": "940 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3bce-706e-bf8d-8e7af7c5bd4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3bce-706e-bf8d-8e7af7c5bd4b",
        "storage_key": "property/6767906449165940/019d01aa-3bce-706e-bf8d-8e7af7c5bd4b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5729528136736299088&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "autumns-in-the-hair",
      "poi_latitude": "47.5970013",
      "poi_longitude": "-120.6610014",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-670-6383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X0iY3ZNmlQRUNjF6Htfg08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d88967f5-5ba1-497e-802d-72842e57ca02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Bridal Hair by Lucy",
      "poi_type": "Health and Wellness",
      "poi_address": "940 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3d08-76eb-b8f2-64f2d50753a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3d08-76eb-b8f2-64f2d50753a7",
        "storage_key": "property/6767906449165940/019d01aa-3d08-76eb-b8f2-64f2d50753a7.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.bridalhairbylucy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2255562271987555450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "bridal-hair-by-lucy",
      "poi_latitude": "47.5970891",
      "poi_longitude": "-120.6610221",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-670-8962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQKJvItNmlQRelyXlu9dTR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_71ebd60f-27da-42b6-978e-a1102a8dcb1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Cascade Medical",
      "poi_type": "Health and Wellness",
      "poi_address": "817 Commercial St, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-3e26-70f9-9192-df9516c9d4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-3e26-70f9-9192-df9516c9d4c6",
        "storage_key": "property/6767906449165940/019d01aa-3e26-70f9-9192-df9516c9d4c6.webp",
        "width": 1280,
        "height": 668
      },
      "poi_business_url": "https://cascademedical.org/?utm_source=GMBSocialClimb&utm_medium=CascadeMedical",
      "poi_directions_map_url": "https://maps.google.com/?cid=16493880072924750536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cascade-medical",
      "poi_latitude": "47.59446490000001",
      "poi_longitude": "-120.6608738",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-5815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-544f-77ac-ac33-7054db147416.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-544f-77ac-ac33-7054db147416",
        "storage_key": "property/6767906449165940/019d01aa-544f-77ac-ac33-7054db147416.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjaNDkoxNmlQRyOKSuokI5uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b7e3c9a0-1b9b-451d-a3f8-b52f278b464a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Snow Lakes Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Leavenworth, WA 98826, USA",
      "poi_short_description": "Hiking area with switchbacks offering scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-4035-739c-bc50-65d1baf4ad74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-4035-739c-bc50-65d1baf4ad74",
        "storage_key": "property/6767906449165940/019d01aa-4035-739c-bc50-65d1baf4ad74.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fs.usda.gov/recarea/okawen/recarea/?recid=58995",
      "poi_directions_map_url": "https://maps.google.com/?cid=10710534309866734191&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "snow-lakes-trailhead",
      "poi_latitude": "47.54407579999999",
      "poi_longitude": "-120.7096568",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 509-548-2550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5458-737b-9266-2cc4c5857e1a",
        "storage_key": "property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBwR0DlVOmlQRb4I9PjV2o5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_45566eb1-b615-437c-bf23-a2c6f9179b10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Waterfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Leavenworth, WA 98826, USA",
      "poi_short_description": "Kid-friendly park with a playground, picnic tables, and opportunities for hiking and tubing.",
      "poi_long_description": "People say this park offers a playground, picnic areas, river access, and flat trails. They highlight the clean and well-maintained facilities, including restrooms, and the beautiful views of the river and surrounding landscape. They also like the easy and relaxing walks along the river and the availability of groomed paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-41ea-73fe-8cc7-36d515816a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-41ea-73fe-8cc7-36d515816a83",
        "storage_key": "property/6767906449165940/019d01aa-41ea-73fe-8cc7-36d515816a83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofleavenworth.com/your-city-hall/departments/public-works/city-parks/waterfront-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=195547754347963115&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "waterfront-park",
      "poi_latitude": "47.5936886",
      "poi_longitude": "-120.6589634",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-548-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5458-737b-9266-2cc4c5857e1a",
        "storage_key": "property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdALIvNNmlQR6yKJgqW5tgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d2a44c5-3a63-4d89-99e3-6484c76edbe4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Enchantment Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Enchantment Park Way, Leavenworth, WA 98826, USA",
      "poi_short_description": "Public park with a playground, baseball fields, and picnic tables, as well as skateboarding and biking facilities.",
      "poi_long_description": "People say this park offers a skate park, pump track, trails, and access to the river. They highlight the clean and well-maintained facilities, and the beautiful scenery. They also like the ample parking and the variety of activities available for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-425d-720d-9e9a-39a9bfd40baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-425d-720d-9e9a-39a9bfd40baf",
        "storage_key": "property/6767906449165940/019d01aa-425d-720d-9e9a-39a9bfd40baf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://cityofleavenworth.com/city-services/parks/enchantment-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=811295857599433982&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "enchantment-park",
      "poi_latitude": "47.5882514",
      "poi_longitude": "-120.6681496",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-548-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5458-737b-9266-2cc4c5857e1a",
        "storage_key": "property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XUQ-fFNmlQR_sz1t0hNQgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fd5ecf2c-6905-429a-a547-82988daed15d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Icicle Ridge Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Icicle Rd, Leavenworth, WA 98826, USA",
      "poi_short_description": "Popular hiking area with meadows and wildflowers offering scenic views of Leavenworth.",
      "poi_long_description": "People say this hiking area offers a challenging trail with beautiful wildflowers and breathtaking views. They highlight the peaceful and calming atmosphere at the top, perfect for enjoying lunch and soaking in the scenery. They also like the easy parking and convenient port-a-potty at the trailhead.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-4414-775c-a953-ff9b02c8e0fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-4414-775c-a953-ff9b02c8e0fe",
        "storage_key": "property/6767906449165940/019d01aa-4414-775c-a953-ff9b02c8e0fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wta.org/go-hiking/hikes/icicle-ridge-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=20226101789391885&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "icicle-ridge-trailhead",
      "poi_latitude": "47.5688344",
      "poi_longitude": "-120.6810634",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5458-737b-9266-2cc4c5857e1a",
        "storage_key": "property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58iB6xlamlQRDfxYTIjbRwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_02a55e9e-e2d8-4aa8-93a5-1b1be7cb0573",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Front Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "820 Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "Park featuring a gazebo, a public restroom, and picnic tables, plus winter festivals.",
      "poi_long_description": "People say this park offers a gazebo, lights, and music, and is a fun place to relax and enjoy the festive atmosphere, especially during the holidays. They highlight the beautiful decorations, the family-friendly vibe, and the convenient location in the heart of town with nearby shops and restaurants. They also like the shade provided by the trees and the availability of restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-45ee-763b-aa1c-bb6cb4e3344c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-45ee-763b-aa1c-bb6cb4e3344c",
        "storage_key": "property/6767906449165940/019d01aa-45ee-763b-aa1c-bb6cb4e3344c.webp",
        "width": 1280,
        "height": 903
      },
      "poi_business_url": "https://cityofleavenworth.com/your-city-hall/departments/public-works/city-parks/front-street-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9190487620794738266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "front-street-park",
      "poi_latitude": "47.595618",
      "poi_longitude": "-120.6618821",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-548-5807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5458-737b-9266-2cc4c5857e1a",
        "storage_key": "property/6767906449165940/019d01aa-5458-737b-9266-2cc4c5857e1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyyZZItNmlQRWmYYPswri38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_285bb97e-878f-4ccf-8a09-76952e7d6773",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Leavenworth Icicle Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Icicle Station, 11645 North Rd, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-4776-706b-8c52-bef440718f7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-4776-706b-8c52-bef440718f7c",
        "storage_key": "property/6767906449165940/019d01aa-4776-706b-8c52-bef440718f7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LWA",
      "poi_directions_map_url": "https://maps.google.com/?cid=15296646245681449317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "leavenworth-icicle-station",
      "poi_latitude": "47.6060305",
      "poi_longitude": "-120.6432536",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-584f-746b-8e8c-c4ac617cda4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-584f-746b-8e8c-c4ac617cda4c",
        "storage_key": "property/6767906449165940/019d01aa-584f-746b-8e8c-c4ac617cda4c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-wnI4BNmlQRZcmnILeaSNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e1bc69aa-22c8-46e4-a0fc-93fb19802429",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Leavenworth City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-47dc-77a9-8c29-a86dca07dd53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-47dc-77a9-8c29-a86dca07dd53",
        "storage_key": "property/6767906449165940/019d01aa-47dc-77a9-8c29-a86dca07dd53.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cityofleavenworth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10299265040766549657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "leavenworth-city-hall",
      "poi_latitude": "47.5950679",
      "poi_longitude": "-120.664223",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-548-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5887-7588-977d-e9de91db20a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5887-7588-977d-e9de91db20a1",
        "storage_key": "property/6767906449165940/019d01aa-5887-7588-977d-e9de91db20a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYx7dUYtNmlQRmT59mvxW7o4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_61a12ee6-5e7b-49d6-9632-7d89bd96a883",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Hans Christian Andersen Carriage Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8th and, Front St, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-49ea-7320-8870-a100e2d016aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-49ea-7320-8870-a100e2d016aa",
        "storage_key": "property/6767906449165940/019d01aa-49ea-7320-8870-a100e2d016aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.andersencarriage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14500355110293853667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "hans-christian-andersen-carriage-company",
      "poi_latitude": "47.59502750000001",
      "poi_longitude": "-120.6626811",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-885-0084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1UwJH9SmlQR49UViiWcO8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_95c7f6a3-8245-4f63-8422-335b3e6ecaf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "poi_name": "Wenatchee River Dam",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13901 US Hwy 2, Leavenworth, WA 98826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-4b53-72df-9922-477a536c4552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01aa-4b53-72df-9922-477a536c4552",
        "storage_key": "property/6767906449165940/019d01aa-4b53-72df-9922-477a536c4552.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13558481745534404120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "wenatchee-river-dam",
      "poi_latitude": "47.62298089999999",
      "poi_longitude": "-120.7253204",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01aa-5457-7208-a9d4-74d0688460b0",
        "storage_key": "property/6767906449165940/019d01aa-5457-7208-a9d4-74d0688460b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIUYH-ChSmlQRGEYyyE9nKbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fae2398ce91e461648722461",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_37245581f3e26b8d7923d18d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_feddb74c24010cdf70e12bf5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_7773575a51124b971c4d9b49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6752bc9164c423aa0f5fc24f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2cd60e6f83038a525bbbf7d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f4910a43-cb42-4ec8-95fd-266e77f451db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "rating": "5.0",
      "name": "Alexander Razlivanov",
      "text": "moved into Autumn Haus, and this place honestly exceeded all my expectations. The building is extremely well-maintained, the layouts are modern and spacious, and the whole property feels peaceful and welcoming. You can tell the management and maintenance team really care — any questions or issues are handled quickly and professionally.\n\nThe amenities are a huge bonus too: the fire pits, BBQ areas, and pool make the place feel like a small resort. The location is perfect — just a short walk from downtown Leavenworth, but still quiet enough to feel private.\n\nIf you’re looking for a comfortable, clean, and beautifully designed place to live in Leavenworth, Autumn Haus is definitely one of the best choices. Highly recommend!",
      "date": "2025-12-07",
      "title": ""
    },
    {
      "id": "custom_ed7af10c-888d-4479-8b65-99eddd862ce1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "rating": "5.0",
      "name": "Ca r",
      "text": "Autumn Haus is located in a truly gorgeous area that enhances the overall living experience. When we showed up at the door to the Autumn Haus business office, Katt was so gracious and kind, making us feel welcome right from the start. Each and every time we called and reached out to Katt for more details, she was more than happy to answer all of our questions promptly. We are so happy with our decision to move here. My husband and I absolutely love it, and getting to live in a brand newly built apartment makes us feel incredibly lucky. The amenities, including the pool, fire pits, and BBQ areas, are fantastic, and we cannot wait to use them all!",
      "date": "2025-11-21",
      "title": ""
    },
    {
      "id": "custom_d663a62d-d6d7-4d89-be05-ea59e7673977",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "rating": "5.0",
      "name": "Morgan",
      "text": "My boyfriend and I absolutely love living in this apartment complex. We have two super amazing people running the office,  Kirk and Kat. Kirk and Kat go above and beyond to make sure each resident is happy, satisfied, and are always open/available to help you weather that’s moving in questions to simple everyday questions. We absolutely love these two and would 100% recommend these apartments if your looking for a kind beautiful atmosphere.",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_f7f1ce0b-e130-4c89-928b-911817227a00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "rating": "5.0",
      "name": "Blossom Jaramillo",
      "text": "My son and I are so happy to be here and a part of this new little community they're building here at Autumn Haus. I was born and raised in Leavenworth and have been living outside of town because of the difficulties of obtaining a home, and being able to afford it, so when Autumn Haus opened up, I was so excited to seize the opportunity to move back. Immediately upon inquiring about the property, Kirk was so awesome and kind. He displayed such great patience and understanding with me. I was so unsure at first since I'm a single parent and have to take a lot into consideration. He was so helpful and accommodating, Kat as well, they just feel genuinely nice, which is very rare nowadays. I haven't gotten to know too many neighbors yet, but the ones I have are so nice, and I love meeting all the dogs as well. There are so many beautiful views, and many places to walk your dog, plus it's close enough to the schools you can make your kids walk home too!  Thank you to everyone contributing to making this such a wonderful place, we appreciate you!\nAlso, my son says they have the best chocolate in the office and to never run out of it! (and sorry for that one time he took a lot lol)",
      "date": "2025-12-09",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_00b5bba2-fc92-4b12-a1d9-d713e815462b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-3dc3-740b-b1ec-94cd26961d6b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with hardwood floors and a large window.",
        "public_id": "019d01ab-3dc3-740b-b1ec-94cd26961d6b",
        "storage_key": "property/6767906449165940/019d01ab-3dc3-740b-b1ec-94cd26961d6b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus| Studio - 508 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MqkLd87xyRv"
    },
    {
      "id": "custom_74340823-6e02-4a7f-b299-ed82900e0884",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-4884-77cf-ae5d-7cfecf1c69fd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and a sleek faucet.",
        "public_id": "019d01ab-4884-77cf-ae5d-7cfecf1c69fd",
        "storage_key": "property/6767906449165940/019d01ab-4884-77cf-ae5d-7cfecf1c69fd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus 1x1 - 572 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YxiBcZ364ir"
    },
    {
      "id": "custom_0f385287-c3a3-4431-b7fc-f554ea3bfce1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-3d1a-7337-be5e-8d673aa6aec9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with quartz countertops and stainless steel appliances.",
        "public_id": "019d01ab-3d1a-7337-be5e-8d673aa6aec9",
        "storage_key": "property/6767906449165940/019d01ab-3d1a-7337-be5e-8d673aa6aec9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus | 1x1 - 699 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1hDh1z8wKqU"
    },
    {
      "id": "custom_ea6d5a81-6d90-4505-8f85-d9ab3d4a0c63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-3d4f-74c7-a38a-7c0d276edcfd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen island with sink and dishwasher, open to living area and balcony.",
        "public_id": "019d01ab-3d4f-74c7-a38a-7c0d276edcfd",
        "storage_key": "property/6767906449165940/019d01ab-3d4f-74c7-a38a-7c0d276edcfd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus | 1X1 - 837 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qadcjdGygMY"
    },
    {
      "id": "custom_d78b42cf-1035-4ee5-b08f-7fb3b8dccaf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-3d52-7208-9127-6495e5c1cde3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen island with sink, view into living room and bedroom.",
        "public_id": "019d01ab-3d52-7208-9127-6495e5c1cde3",
        "storage_key": "property/6767906449165940/019d01ab-3d52-7208-9127-6495e5c1cde3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus | Model - 1x1 - 837 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5rYGvvYWHPy"
    },
    {
      "id": "custom_451408b0-fa67-4f39-9556-dd9e96558272",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-47c7-7179-9327-b44f92c4a4ea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and ample counter space.",
        "public_id": "019d01ab-47c7-7179-9327-b44f92c4a4ea",
        "storage_key": "property/6767906449165940/019d01ab-47c7-7179-9327-b44f92c4a4ea.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus | 2x2 - 997 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YcqDiE3cWXF"
    },
    {
      "id": "custom_bf92de13-4ce7-4322-aa45-7ffb2ccfa57b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019d01ab-4884-77cf-ae5d-813468f6e159.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with large windows and wood-look flooring.",
        "public_id": "019d01ab-4884-77cf-ae5d-813468f6e159",
        "storage_key": "property/6767906449165940/019d01ab-4884-77cf-ae5d-813468f6e159.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Autumn Haus | 2X2 - 1115 SQ. FT.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zJpMZDe3bfR"
    },
    {
      "id": "custom_ec1f0f24-39bf-4e79-9e3e-0c1fcbe93117",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165940/019faf9e-4b6e-742c-a6a5-fc479ab56289.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019faf9e-4b6e-742c-a6a5-fc479ab56289",
        "storage_key": "property/6767906449165940/019faf9e-4b6e-742c-a6a5-fc479ab56289.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": " Autumn Haus | Townhouse 3 X 2.5",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dzwNvzZWwXv"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-c233-7019-a2a3-9fa8b9ca37b8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "autumn-haus",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940"
    },
    {
      "lead_collector_id": "0198aa47-c297-71ec-8bfa-a3698f3ebbc2",
      "lead_source": "FACEBOOK_ADS",
      "name": "autumn-haus",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940"
    },
    {
      "lead_collector_id": "0198aa47-c2fb-776c-8bd8-5c41db57d90d",
      "lead_source": "LANDING_PAGE",
      "name": "autumn-haus",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-in-home-laundry-leavenworth-wa",
      "search_query": "apartments with in-home laundry in Leavenworth WA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Laundry Options",
      "h2_subtitle": "Discover our Leavenworth WA apartments featuring in-home laundry convenience. Enjoy modern living with accessible laundry facilities.",
      "page_copy": "Welcome to Autumn Haus, where mountain-town ease meets modern apartment living in Leavenworth, WA. Our apartments offer the convenience of in-home laundry facilities, designed to make your life easier. Step into a world of comfort and luxury, available in our studio to three-bedroom layouts. Our apartments are adorned with elegant finishes like quartz countertops and luxury vinyl plank floors.\n\nAt Autumn Haus, you'll find more than just an apartment home; you'll discover a lifestyle. Enjoy the community clubhouse or relax on a private patio or balcony with scenic views. Experience the beauty of Leavenworth with the added convenience of in-home laundry, making chores a breeze. Don't miss out—schedule a tour and see why our community sets the standard for modern living in the Washington State area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Leavenworth WA Apartments with In-Home Laundry",
      "seo_description": "Explore Leavenworth WA apartments with in-home laundry at Autumn Haus and enjoy modern comforts and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-chelan-county",
      "search_query": "air-conditioned apartments in Chelan County",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Chelan County",
      "h2_subtitle": "Enjoy comfortable living with our air-conditioned apartments in Chelan County. Discover the perfect home at Autumn Haus.",
      "page_copy": "Find your perfect retreat at Autumn Haus, where comfort meets convenience in Chelan County. Our air-conditioned apartments provide a refreshing escape from the hustle and bustle of life, offering studio to three-bedroom layouts that cater to all your needs. Step inside and be greeted by thoughtful designs featuring 9-foot ceilings, luxury vinyl plank floors, and quartz countertops.\n\nLiving at Autumn Haus means enjoying not only air-conditioned interiors but also a range of amenities that elevate your living experience. Relax in our community clubhouse or take in the stunning views from your own private patio or balcony. Nestled in the serene Washington State area, Autumn Haus invites you to experience spirited apartment living in Leavenworth, tailored just for you. Schedule a visit today and find out why our community stands out as a premier choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Chelan County",
      "seo_description": "Discover air-conditioned apartments in Chelan County at Autumn Haus, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartment-garage-parking-leavenworth",
      "search_query": "apartment with garage parking in Leavenworth",
      "category": "Amenity",
      "h1_title": "Apartments with Garage Parking in Leavenworth",
      "h2_subtitle": "Enjoy the convenience of garage parking in our Leavenworth apartments. Autumn Haus offers modern comfort with secure, easy parking access.",
      "page_copy": "Autumn Haus in Leavenworth offers you the practical luxury of garage parking, providing safety and convenience right at your doorstep. Our elegant apartments range from studio to three-bedroom layouts, each thoughtfully designed with modern finishes like quartz countertops and luxury vinyl plank floors. Enjoy the peace of mind that comes with knowing your vehicle is shielded from the elements, allowing you to fully appreciate all the perks of mountain-town living.\n\nLocated in the heart of Chelan County, Autumn Haus is more than just a home; it's a lifestyle. Experience resort-style living with amenities including a community clubhouse and private outdoor spaces. Whether you're seeking the ease of garage parking or the tranquility of a private patio with scenic views, Autumn Haus ensures you enjoy the best of Leavenworth living. Secure your spot today—your new home awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Leavenworth Apartments with Garage Parking",
      "seo_description": "Find Leavenworth apartments with garage parking at Autumn Haus, offering modern comforts and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-near-washington-state-area",
      "search_query": "luxury apartments with pool near Washington State Area",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with a Pool Near Washington State",
      "h2_subtitle": "Discover upscale living at Autumn Haus, featuring luxury apartments with a pool near the Washington State area.",
      "page_copy": "Experience the pinnacle of luxury living at Autumn Haus, where our upscale apartments are complemented by resort-style amenities, including a stunning pool. Perfectly situated near the Washington State area, our community offers studio to three-bedroom layouts, each designed for ultimate comfort with features like quartz countertops and luxury vinyl plank floors. Escape from the everyday stresses and dive into relaxation at our sparkling pool.\n\nAutumn Haus is not just an apartment complex; it's your getaway nestled in Leavenworth, providing residents with exclusive amenities. Beyond the relaxing pool, enjoy our clubhouse and private balconies or patios with breathtaking views. Our community embodies the spirit of opulence and tranquility, offering you the lifestyle you deserve. Schedule a visit and see firsthand how our luxury apartments redefine apartment living in Chelan County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Near Washington State",
      "seo_description": "Explore luxury apartments with a pool near Washington State at Autumn Haus, offering sophisticated living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-dog-run-leavenworth",
      "search_query": "dog-friendly apartments with dog run in Leavenworth",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Dog Run in Leavenworth",
      "h2_subtitle": "Autumn Haus offers dog-friendly apartments in Leavenworth featuring a dedicated dog run. Perfect for pet lovers seeking comfort and convenience.",
      "page_copy": "Autumn Haus is delighted to welcome you and your furry friends to our dog-friendly community in Leavenworth. Designed with pet lovers in mind, our apartments not only boast modern comforts but also a dedicated dog run where your pup can play and stretch their legs. Whether you prefer a cozy studio or a spacious three-bedroom, each apartment offers modern finishes like quartz countertops and luxury vinyl plank floors.\n\nNestled in the scenic beauty of Chelan County, Autumn Haus offers more than just pet-friendly living. Residents enjoy resort-like amenities including a welcoming clubhouse and private patios or balconies with stunning views. Our dog run ensures your pet is as happy at home as you are. Discover the pet-friendly lifestyle at Autumn Haus and make it your new home in Leavenworth today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Dog Run in Leavenworth",
      "seo_description": "Find dog-friendly apartments with a dog run in Leavenworth at Autumn Haus—perfect for pet enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "studio-apartments-leavenworth-wa",
      "search_query": "studio apartments Leavenworth WA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Leavenworth, WA",
      "h2_subtitle": "Explore our modern studio apartments in Leavenworth, WA. Autumn Haus combines comfort and style in every unit.",
      "page_copy": "Autumn Haus invites you to discover our stylish studio apartments in the charming town of Leavenworth, WA. Each studio is thoughtfully designed with a modern aesthetic, featuring high-end finishes such as quartz countertops, luxury vinyl plank floors, and impressive 9-foot ceilings. Experience the perfect blend of comfort and style that suits your lifestyle.\n\nLocated in Chelan County, Autumn Haus offers more than just a place to live; it’s a community where convenience and modern living come together. Alongside our chic studios, enjoy access to amenities like our inviting clubhouse and private patios or balconies with great views. Whether you're new to the area or looking for a fresh start, our studio apartments provide a perfect blend of function and beauty to fit your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Leavenworth, WA",
      "seo_description": "Discover modern studio apartments in Leavenworth, WA at Autumn Haus, offering sleek designs and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-chelan-county",
      "search_query": "1 bedroom apartments Chelan County",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Chelan County",
      "h2_subtitle": "Autumn Haus presents cozy 1 bedroom apartments in the heart of Chelan County. Enjoy scenic living with modern amenities.",
      "page_copy": "Find the perfect blend of coziness and modern elegance at Autumn Haus, where our 1 bedroom apartments in Chelan County await you. Each unit features a superb layout complemented by luxury vinyl plank floors, quartz countertops, and towering 9-foot ceilings that create an airy and inviting atmosphere. Experience a home that matches both style and convenience, located in the picturesque setting of Chelan County.\n\nBeyond your doorstep, Autumn Haus offers a wealth of amenities for our residents. Relax in our state-of-the-art clubhouse, savor the views from your private patio or balcony, and explore the beautiful surroundings of Leavenworth. Our community is designed not just as a place to live, but as a serene retreat that enhances your lifestyle. Choose Autumn Haus for a 1 bedroom apartment that offers you both modern comforts and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Chelan County",
      "seo_description": "Explore charming 1 bedroom apartments in Chelan County at Autumn Haus—enjoy modern amenities and a picturesque setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-98826",
      "search_query": "2 bedroom apartments near 98826",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 98826",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near 98826 at Autumn Haus. Experience modern living with excellent amenities.",
      "page_copy": "Located in the enchanting town of Leavenworth, Autumn Haus offers spacious 2 bedroom apartments near the 98826 area, perfect for families or roommates desiring comfortable living. Each apartment is meticulously designed, featuring luxury vinyl plank floors and sleek quartz countertops, complemented by lofty 9-foot ceilings that enhance the open layout.\n\nAutumn Haus is more than just a home—it's a community that provides an array of amenities designed to enrich your living experience. Relax in our inviting clubhouse or enjoy serene evenings on your private patio or balcony, all against the backdrop of Chelan County's scenic beauty. Embrace a lifestyle of convenience and sophistication in our 2 bedroom apartments, ideally situated in Leavenworth's welcoming environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 98826",
      "seo_description": "Find spacious 2 bedroom apartments near 98826 at Autumn Haus and enjoy modern amenities in Leavenworth.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-washington-state",
      "search_query": "3 bedroom apartments Washington State",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Washington State",
      "h2_subtitle": "Explore expansive 3 bedroom apartments at Autumn Haus, located in the heart of Washington State. Spacious living designed for you.",
      "page_copy": "Welcome to Autumn Haus, where our expansive 3 bedroom apartments in Washington State offer a perfect retreat for larger households or those needing extra space. Each apartment is tastefully appointed with luxury finishes, including quartz countertops and elegant luxury vinyl plank flooring. With 9-foot ceilings, these homes provide a sense of openness and refinement that is truly exceptional.\n\nSituated in the charming area of Leavenworth, Autumn Haus ensures that residents enjoy both modern comforts and the natural beauty of the Washington State Area. You will find an array of inviting amenities such as a spacious clubhouse and personal patios or balconies, perfect for unwinding or entertaining guests. At Autumn Haus, our 3 bedroom homes are designed with your lifestyle in mind, offering a harmonious blend of luxury, privacy, and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Washington State",
      "seo_description": "Discover spacious 3 bedroom apartments at Autumn Haus in Washington State. Enjoy modern amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-near-upper-valley-christian-school-chelan-county",
      "search_query": "apartments near Upper Valley Christian School Chelan County",
      "category": "School",
      "h1_title": "Apartments Near Upper Valley Christian School",
      "h2_subtitle": "Find comfortable apartments near Upper Valley Christian School at Autumn Haus. Convenient living in Chelan County.",
      "page_copy": "Located conveniently in Chelan County, Autumn Haus offers modern apartments near Upper Valley Christian School, allowing families and students easy access to quality education. Our community features various floor plans from studio to 3-bedroom layouts, each equipped with elegant finishes like quartz countertops and luxury vinyl plank flooring.\n\nExperience the ease of mountain-town living combined with modern apartment comfort. Relax in our inviting clubhouse or on your private patio or balcony while taking in breathtaking views of the surrounding landscape. With quick access to local amenities and the prestigious Upper Valley Christian School, Autumn Haus stands as a prime choice for those seeking a dynamic and enriched lifestyle near Leavenworth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Upper Valley Christian School",
      "seo_description": "Explore Autumn Haus for apartments near Upper Valley Christian School, offering modern amenities and easy access in Chelan County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-near-cascade-medical-leavenworth",
      "search_query": "apartments near Cascade Medical Leavenworth",
      "category": "Hospital",
      "h1_title": "Apartments Near Cascade Medical",
      "h2_subtitle": "Discover convenient apartments near Cascade Medical in Leavenworth. Enjoy modern amenities and scenic views at Autumn Haus.",
      "page_copy": "Autumn Haus offers thoughtfully designed apartments near Cascade Medical in Leavenworth, providing both convenience and comfort for medical professionals, patients, and families. Our variety of stylish floor plans, ranging from studio to three-bedroom options, ensures a perfect fit for any lifestyle.\n\nEach apartment features luxury vinyl plank floors and sophisticated quartz countertops, creating a refined living space. Residents can unwind in our welcoming clubhouse or enjoy the fresh air from their private patio or balcony. Nestled in the Washington State Area, Autumn Haus delivers a harmonious blend of modern living and easy access to Leavenworth's essential services, like Cascade Medical, making it an ideal location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cascade Medical Leavenworth",
      "seo_description": "Find stylish apartments near Cascade Medical in Leavenworth at Autumn Haus, offering modern living with elegant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-near-waterfront-park-leavenworth",
      "search_query": "apartments near Waterfront Park Leavenworth",
      "category": "Park",
      "h1_title": "Apartments Near Waterfront Park",
      "h2_subtitle": "Enjoy proximity to Waterfront Park with our modern apartments in Leavenworth. Autumn Haus offers scenic views and convenient amenities.",
      "page_copy": "Nestled in scenic Leavenworth, Autumn Haus presents an ideal location with apartments near Waterfront Park, offering easy access to natural beauty and recreational activities. Our community features a range of floor plans from studios to spacious three-bedroom units, each with modern and elegant interiors like luxury vinyl plank flooring and quartz countertops.\n\nResidents of Autumn Haus can relish in the serene environment from their private patios or balconies, while community amenities like a luxurious clubhouse enhance the living experience. Positioned within the Washington State Area, our apartments offer tranquility and connectivity, making daily life as enjoyable as a stroll through Waterfront Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Waterfront Park Leavenworth",
      "seo_description": "Discover Autumn Haus, offering modern apartments near Waterfront Park in Leavenworth. Enjoy luxury amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-close-to-enchantment-park-wa",
      "search_query": "apartments close to Enchantment Park WA",
      "category": "Park",
      "h1_title": "Apartments Close to Enchantment Park",
      "h2_subtitle": "Live close to Enchantment Park, WA, at Autumn Haus. Explore modern living in a beautiful mountain setting.",
      "page_copy": "Autumn Haus offers the perfect mix of convenience and style with apartments close to Enchantment Park, WA. Explore comfortable living options ranging from studio to three-bedroom layouts, all featuring high-end finishes like quartz countertops and luxury vinyl plank floors.\n\nOur residents enjoy breathtaking views and modern conveniences, such as a welcoming clubhouse and the option of a private patio or balcony. Located in the vibrant Washington State Area, Autumn Haus ensures that natural beauty and outdoor adventures are only a short distance away, making your lifestyle both active and enjoyable near the charming Enchantment Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Enchantment Park WA",
      "seo_description": "Explore Autumn Haus for apartments close to Enchantment Park, WA. Experience luxury living in a picturesque mountain environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449165940",
      "source": "generator",
      "page_item_url": "apartments-surrounding-front-street-park-chelan-county",
      "search_query": "apartments surrounding Front Street Park Chelan County",
      "category": "Park",
      "h1_title": "Apartments Surround Front Street Park",
      "h2_subtitle": "Experience life near Front Street Park in Chelan County. Autumn Haus offers modern comforts and scenic mountain views.",
      "page_copy": "Autumn Haus features exceptional apartments surrounding Front Street Park in the charming area of Chelan County. Our community offers a range of stylish floor plans, from cozy studios to expansive three-bedroom units, each equipped with luxurious amenities like quartz countertops and luxury vinyl plank flooring.\n\nResidents enjoy access to our state-of-the-art clubhouse and have the option of a private patio or balcony to take in the natural beauty of Leavenworth. Nestled in the Washington State Area, these apartments provide easy connectivity to Front Street Park along with a vibrant lifestyle full of natural charm and urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with modern furniture, fireplace, and large windows.",
        "public_id": "01a0378b-57b2-7471-a1a7-24a6d562c263",
        "storage_key": "property/6767906449165940/01a0378b-57b2-7471-a1a7-24a6d562c263.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Surround Front Street Park Chelan County",
      "seo_description": "Discover Autumn Haus, providing elegant apartments around Front Street Park in Chelan County. Enjoy a luxurious living experience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5757"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9402129124"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W36P7JV9"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.1"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "13eaf7db-c317-4bec-9e97-20a334133780"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Aster"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/70f05313-6d26-4ef7-a642-b0816824655b/app.js?property=70f05313-6d26-4ef7-a642-b0816824655b&amp;propertyName=Autumn+Haus&amp;channelUuid=fb6a5926-80f0-11ef-b558-42010aa8d42b&amp;buttonbgcolor=eec170\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "38834764603"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp2dqx5vxl"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IksrSXBxOWd1QkVrdjZnRk5Mclo1SHc9PSIsInZhbHVlIjoic0N4aHlLWXVUYWVGS1JJNGpMUjhkdz09IiwibWFjIjoiOWY4MDU3MWYyNWNjYjg1N2JhN2E0ODJhZGIxZTljYTNiMDFlNDZjM2Q3ZGUxYmY5OGVhOTliOWU5ZGFmMzc2OSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5757",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9402129124",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561",
  "custom_google_gtm_id": "GTM-W36P7JV9",
  "custom_rollout_phase": "Phase 7.1",
  "custom_rentgrata_token": "13eaf7db-c317-4bec-9e97-20a334133780",
  "custom_vibesites_theme": "Aster",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/70f05313-6d26-4ef7-a642-b0816824655b/app.js?property=70f05313-6d26-4ef7-a642-b0816824655b&amp;propertyName=Autumn+Haus&amp;channelUuid=fb6a5926-80f0-11ef-b558-42010aa8d42b&amp;buttonbgcolor=eec170\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "38834764603",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yjp2dqx5vxl",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IksrSXBxOWd1QkVrdjZnRk5Mclo1SHc9PSIsInZhbHVlIjoic0N4aHlLWXVUYWVGS1JJNGpMUjhkdz09IiwibWFjIjoiOWY4MDU3MWYyNWNjYjg1N2JhN2E0ODJhZGIxZTljYTNiMDFlNDZjM2Q3ZGUxYmY5OGVhOTliOWU5ZGFmMzc2OSJ9",
  "custom_audioeye_site_id": "fe1609b0-eff7-4a42-b84c-7421cb0aa816",
  "custom_audioeye_site_hash": "adcd8f0a9736fcecd32e7b4f219ebf10"
};

export const generatedAt = '2026-10-29T23:11:27.753Z';
